module.exports = __webpack_public_path__ + "static/media/shop_header_image.2104d87b.png";